import { render, staticRenderFns } from "./CompletePasswordReissue.vue?vue&type=template&id=1965f8d4&scoped=true&"
import script from "./CompletePasswordReissue.vue?vue&type=script&lang=js&"
export * from "./CompletePasswordReissue.vue?vue&type=script&lang=js&"
import style0 from "./CompletePasswordReissue.vue?vue&type=style&index=0&id=1965f8d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965f8d4",
  null
  
)

export default component.exports